export default __webpack_public_path__ + "static/media/Rr.878ca787.wav";